import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  // baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3000/api',
  // baseURL : 'https://meilisearch.wordcloudmaster.com/api/' || 'http://localhost:3000/api',
});

export default api;
